var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultRendererConfig, setupBingAerialImagery } from "./index";
import { sceneFlyover } from "./utils/sceneFlyover";
export function meshTilesetFlyover4(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Mesh Tileset Flyover 4" +
                "</h1>" +
                "<p>" +
                "The camera will fly over a mesh tileset. The tileset should render normally." +
                "</p>";
        const initialWait = 5;
        const time = 2;
        const durations = [0, initialWait, time, time, time, time, time, time, time, time];
        const positions = [
            { longitude: 2.529446519077235, latitude: -0.6601489019803184, height: 35.788442490454884 },
            { longitude: 2.529446519077235, latitude: -0.6601489019803184, height: 35.788442490454884 },
            { longitude: 2.529447818278574, latitude: -0.6601262961521914, height: 33.13701242619221 },
            { longitude: 2.52940515808579, latitude: -0.660123590576525, height: 35.23939316434023 },
            { longitude: 2.529403845170704, latitude: -0.6601473095732735, height: 23.687296589845523 },
            { longitude: 2.529414296415945, latitude: -0.6601421442967466, height: 9.499730184912352 },
            { longitude: 2.5294149521348626, latitude: -0.660133593816487, height: 10.663424417721801 },
            { longitude: 2.5294352721458604, latitude: -0.6601332679144082, height: 10.277748491654847 },
            { longitude: 2.5294324446227594, latitude: -0.6601445785560376, height: 8.37243058925021 },
            { longitude: 2.5294321047780803, latitude: -0.6601433823043944, height: 17.341746157050714 },
        ];
        const focuses = [
            { longitude: 2.5294264156923245, latitude: -0.6601375694671061, height: 16.069573228716113 },
            { longitude: 2.5294264156923245, latitude: -0.6601375694671061, height: 16.069573228716113 },
            { longitude: 2.5294264156923245, latitude: -0.6601375694671061, height: 16.069573228716113 },
            { longitude: 2.5294264156923245, latitude: -0.6601375694671061, height: 16.069573228716113 },
            { longitude: 2.5294264156923245, latitude: -0.6601375694671061, height: 16.069573228716113 },
            { longitude: 2.529414255864825, latitude: -0.6601329182789171, height: 8.80289899439442 },
            { longitude: 2.5294352105138014, latitude: -0.6601340050830465, height: 8.37441957347285 },
            { longitude: 2.5294349787471613, latitude: -0.6601416407697427, height: 8.09322352757647 },
            { longitude: 2.529431606949871, latitude: -0.6601443787624861, height: 16.14358699328076 },
            { longitude: 2.5294311242433847, latitude: -0.6601438747287247, height: 15.460676157133586 },
        ];
        yield sceneFlyover(defaultRendererConfig(container), durations, positions, focuses, (renderer) => __awaiter(this, void 0, void 0, function* () {
            // Scene setup
            setupBingAerialImagery(renderer);
            const object = yield renderer.getObjectFactory().createTileset({
                type: "direct",
                url: "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/models/port+melbourne+hq/Production_2.json",
            });
            renderer.getWorld().addObject(object);
        }));
    });
}
